export default __webpack_public_path__ + "static/icon-callout-hp-connect-614dba8cb33530a2ff3adb6a3f659465.png";